import { render } from "./ApprovedAgentsByRetailer.vue?vue&type=template&id=64169266&scoped=true"
import script from "./ApprovedAgentsByRetailer.vue?vue&type=script&lang=js"
export * from "./ApprovedAgentsByRetailer.vue?vue&type=script&lang=js"

import "./ApprovedAgentsByRetailer.vue?vue&type=style&index=0&id=64169266&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64169266"]])

export default __exports__